/* eslint-disable react/jsx-props-no-spreading */
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { Default } from '../pages/_layouts/default'
import { cookies } from '../utils/cookies'

interface PrivateRouteProps extends RouteProps {
  // tslint:disable-next-line:no-any
  component: any
  requiredPermissions?: string[]
  isPublic?: boolean
}

export default function RouteWrapper(props: PrivateRouteProps) {
  const { component: Component, requiredPermissions = [], isPublic = false, ...rest } = props

  const { isAuthenticated, hasPermission } = useAuth()

  const token = cookies.get('@AXAuth:Token')

  const Layout = Default

  const requiresAuth = !isPublic

  if (requiresAuth && !token) {
    return <Redirect to="/" />
  }

  if (requiresAuth && requiredPermissions.length && !hasPermission(requiredPermissions)) {
    return <Redirect to="/forbidden" />
  }

  return (
    <Route
      {...rest}
      render={(p) => (
        <Layout openLayout={Boolean(token)}>
          <Component {...p} />
        </Layout>
      )}
    />
  )
}
